/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { PatientWithDetailedReportState } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import {
  getPatientWithDetailedReportsById,
  GetPatientWithDetailedReportsByIdDto,
} from '@/jsonapi/PatientWithDetailedReports'
import { addOrUpdateSameKeyObjectInArray } from '@/store/utils/api'

const state: PatientWithDetailedReportState = {
  patientWithDetailedReports: [],
}

const mutations = {
  [MutationNames.updatePatientWithDetailedReports](state: PatientWithDetailedReportState, payload): void {
    state.patientWithDetailedReports = payload
  },
}

const actions = {
  async [ActionNames.getPatientWithDetailedReportsById](
    { commit, state },
    payload: GetPatientWithDetailedReportsByIdDto
  ): Promise<void> {
    const results = camelcaseKeysDeep(await getPatientWithDetailedReportsById(payload))
    const newReports = addOrUpdateSameKeyObjectInArray(state.patientWithDetailedReports, results[0], 'id')
    commit(MutationNames.updatePatientWithDetailedReports, newReports)
  },
}

export default {
  name: ModuleNames.patientWithDetailedReports,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
